module.exports = __webpack_public_path__ + "static/media/DefaultImage.98599829.png";